import { TextFieldStyled } from '@nike/nike-design-system-components';
import PropTypes from 'prop-types';
import React from 'react';

import '../../../reusable/infoIconRow.css';
import { useGetLocalization } from '../../../../hooks';
import { ID_DEFAULT_FLOAT, ID_SAFE_FLOOR, ID_SAFE_NUMBER } from '../../../../utils/dom-element-ids';
import { ButtonSubmit, MultipleCurrencyInput, SafeFloorInformationModal } from '../../../reusable';

function AdjustSafeForm({
  defaultFloatChangeMessage,
  newDefaultFloat,
  newDefaultFloatError,
  setNewDefaultFloat,
  originalDefaultFloat,
  newSafeFloor,
  newSafeFloorError,
  setNewSafeFloor,
  originalSafeFloor,
  safeFloorChangeMessage,
  submitLoading,
  submitSuccess,
  isDisabled,
  adjustSafe,
  submitError,
  safeNumber,
  safeName,
  safeDataError,
  currencyCode,
  setCurrency,
  responseError,
}) {
  const getLocalization = useGetLocalization();
  return (
    <>
      <TextFieldStyled
        readOnly
        error={!!safeDataError}
        errorMessage={safeDataError}
        id={ID_SAFE_NUMBER}
        label={getLocalization('lbl.safe-number')}
        name="safeNumber"
        placeholder={`${getLocalization('lbl.safe')}: ${safeName} ${getLocalization(
          'lbl.number',
        )}: ${safeNumber}`}
        style={{ textAlign: 'initial' }}
      />
      <MultipleCurrencyInput
        isReadOnly
        currency={currencyCode}
        setCurrency={setCurrency}
        id="originalDefaultFloat"
        label={getLocalization('lbl.default-float')}
        name="originalDefaultFloat"
        value={originalDefaultFloat}
      />
      <MultipleCurrencyInput
        isRequired
        currency={currencyCode}
        error={!!newDefaultFloatError}
        errorMessage={newDefaultFloatError}
        id={ID_DEFAULT_FLOAT}
        label={getLocalization('lbl.new-float')}
        message={defaultFloatChangeMessage}
        name="defaultFloat"
        setAmount={setNewDefaultFloat}
        setCurrency={setCurrency}
        setValue={setNewDefaultFloat}
        showErrorMessage={!!newDefaultFloatError}
        value={newDefaultFloat}
      />
      <MultipleCurrencyInput
        isReadOnly
        currency={currencyCode}
        setCurrency={setCurrency}
        id="originalSafeFloor"
        label={getLocalization('lbl.safe-floor')}
        name="originalSafeFloor"
        value={originalSafeFloor}
      />
      <div className="info-icon-row pb3-sm">
        <MultipleCurrencyInput
          isRequired
          currency={currencyCode}
          error={!!newSafeFloorError}
          errorMessage={newSafeFloorError}
          id={ID_SAFE_FLOOR}
          label={getLocalization('lbl.new-safe-floor')}
          message={safeFloorChangeMessage}
          name="safeFloor"
          setAmount={setNewSafeFloor}
          setCurrency={setCurrency}
          setValue={setNewSafeFloor}
          showErrorMessage={!!newSafeFloorError}
          value={newSafeFloor}
        />
        <SafeFloorInformationModal />
      </div>
      <br />
      <ButtonSubmit
        isDisabled={isDisabled || submitLoading || !!submitSuccess}
        isSubmitting={submitLoading}
        label={getLocalization('lbl.adjust-safe')}
        messageError={responseError || submitError}
        messageSuccess={submitSuccess}
        onSubmit={adjustSafe}
      />
    </>
  );
}

AdjustSafeForm.propTypes = {
  adjustSafe: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
  defaultFloatChangeMessage: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  newDefaultFloat: PropTypes.number.isRequired,
  newDefaultFloatError: PropTypes.string.isRequired,
  newSafeFloor: PropTypes.number.isRequired,
  newSafeFloorError: PropTypes.string.isRequired,
  responseError: PropTypes.string.isRequired,
  safeDataError: PropTypes.string.isRequired,
  safeFloorChangeMessage: PropTypes.string.isRequired,
  safeName: PropTypes.string.isRequired,
  safeNumber: PropTypes.number.isRequired,
  setCurrency: PropTypes.func.isRequired,
  setNewDefaultFloat: PropTypes.func.isRequired,
  setNewSafeFloor: PropTypes.func.isRequired,
  submitError: PropTypes.string.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  submitSuccess: PropTypes.string.isRequired,
  originalDefaultFloat: PropTypes.number.isRequired,
  originalSafeFloor: PropTypes.number.isRequired,
};

export default AdjustSafeForm;
